export enum RestorePointOrigin {
    Backup = 0,
    ArchiveCopy = 1,
    Retrieve = 2,
    HotCopy = 3,
    ArchiveCopyExplorable = 4
}
